import React, { Component } from 'react'
import EntityList from './../../components/entityList';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Snackbar from 'material-ui/Snackbar';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import SendIcon from 'material-ui/svg-icons/content/send';
import PostalCodeIcon from 'material-ui/svg-icons/maps/local-post-office';

import utils from '../../misc/utils';
var config = utils.getConfig();

const Styles = {
  sendLesPACButton: {
    margin: 0,
    top: 'auto',
    right: 50,
    bottom: 50,
    left: 'auto',
    position: 'fixed',
  },
  dialogContentStyle: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '1280px',
    maxWidth: 'none'
  },
  postalCodesdialogContentStyle: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '680px',
    maxWidth: 'none'
  }
};

class TrailersLesPAC extends Component {
  constructor(props, context) {
    super(props, context);

    this.onSendConfirm = this.onSendConfirm.bind(this);
    this.sendLesPACConfirm = this.sendLesPACConfirm.bind(this);
    this.closeConfirmSendDialog = this.closeConfirmSendDialog.bind(this);
    this.sendLesPAC = this.sendLesPAC.bind(this);
    this.handleSendResultRequestClose = this.handleSendResultRequestClose.bind(this);
    this.openPostalCodesDialog = this.openPostalCodesDialog.bind(this);
    this.onPostalCodesDialogConfirm = this.onPostalCodesDialogConfirm.bind(this);
    this.closePostalCodesDialog = this.closePostalCodesDialog.bind(this);
    this.handleSelectPostalCodeFieldChanged = this.handleSelectPostalCodeFieldChanged.bind(this);
    this.addPostalCode = this.addPostalCode.bind(this);
    this.removePostalCode = this.removePostalCode.bind(this);

    this.state = {
      sendResultOpen: false,
      sendResultMessage: '',
      sendConfirmDialogOpen: false,
      sendConfirmTrailersCount: 0,
      postalCodesDialogOpen: false,
      availablePostalCodes: [],
      selectedEntity: null,
      selectedEntityTempPostalCodes: [],
      resultCustomPostalCodes: []
    };
  }

  componentDidMount() {
    utils.getDataFromApi('api/postalcodes', (results) => {
      var controls = results.map((item) => {
        return (<MenuItem key={item.Code} value={item.Code} primaryText={`${item.Code} (${item.Description})`} />);
      });

      this.setState({availablePostalCodes : controls});
    }, null);
  }

  onSendConfirm(send){
    if(send){
      this.sendLesPACConfirm();
    }

    this.setState({
      sendConfirmDialogOpen: false,
    });
  }

  sendLesPAC(){
    utils.getDataFromApi('api/trailers?action=getLesPACCount', (result) => {
      this.setState({
        sendConfirmTrailersCount: result.Count,
        sendConfirmDialogOpen: true
      });
    }, () => {
      this.setState({
        sendResultMessage: 'Une erreur est survenue',
        sendResultOpen: true
      });
    });
  }

  sendLesPACConfirm(){
    if (this.state.resultCustomPostalCodes && this.state.resultCustomPostalCodes.length > 0) {
      data.CustomPostalCodes = this.state.resultCustomPostalCodes;
    };

    utils.postDataToApi('api/trailers?action=sendLesPAC', {}, () => {
      this.setState({
        sendResultMessage: 'L\'envoi est en cours de traitement',
        sendResultOpen: true
      });
    }, () => {
      this.setState({
        sendResultMessage: 'Une erreur est survenue',
        sendResultOpen: true
      });
    });
  }

  handleSendResultRequestClose(){
    this.setState({
      sendResultOpen: false,
      sendResultMessage: ''
    });
  };

  closeConfirmSendDialog(){
    this.setState({sendConfirmDialogOpen: false});
  }

  openPostalCodesDialog(entity) {
    this.setState({
      selectedEntity: entity,
      selectedEntityTempPostalCodes: JSON.parse(entity.PostalCodes || '[]'),
      postalCodesDialogOpen: true
    });
  }

  closePostalCodesDialog() {
    this.setState({postalCodesDialogOpen: false});
  }

  onPostalCodesDialogConfirm(accepted){
    const currentCustomPostalCodes = this.state.resultCustomPostalCodes;

    if(accepted){
      if(this.state.selectedEntityTempPostalCodes.filter(postalCode => postalCode.length === 0).length > 0) return;

      this.state.selectedEntity.PostalCodes = JSON.stringify(this.state.selectedEntityTempPostalCodes);
      utils.putDataToApi('api/trailers/' + this.state.selectedEntity.ID, this.state.selectedEntity, null);
    }

    this.setState({
      postalCodesDialogOpen: false,
      selectedEntity: null,
      selectedEntityTempPostalCodes: [],
      resultCustomPostalCodes: currentCustomPostalCodes
    });
  }

  addPostalCode() {
    const postalCodes = this.state.selectedEntityTempPostalCodes;
    postalCodes.push('');
    this.setState({selectedEntityTempPostalCodes: postalCodes});
  }

  removePostalCode(index) {
    const postalCodes = this.state.selectedEntityTempPostalCodes;
    postalCodes.splice(index, 1);
    this.setState({selectedEntityTempPostalCodes: postalCodes});
  }

  handleSelectPostalCodeFieldChanged(index, event, key, payload) {
    const postalCodes = this.state.selectedEntityTempPostalCodes;
    postalCodes[index] = payload;
    this.setState({selectedEntityTempPostalCodes: postalCodes});
  }

  render() {
    return (
      <div>
        <Dialog
          modal={false}
          open={this.state.sendConfirmDialogOpen}
          onRequestClose={this.closeConfirmSendDialog}
          title='LesPAC'
          contentStyle={Styles.dialogContentStyle}
          autoScrollBodyContent={true}
          actions={
            [
              <FlatButton
                label="Envoyer"
                primary={true}
                onTouchTap={() => this.onSendConfirm(true)}
              />,
              <FlatButton
                label="Ok"
                primary={true}
                keyboardFocused={true}
                onTouchTap={() => this.onSendConfirm(false)}
              />,
            ]
          }>
            <div>
              <EntityList apiRoute='api/trailers' baseCriteria='count=1000&scope=lesPACActive' disableSearch={true} allowEdit={false} allowAdd={false} allowDelete={false} displayColumns={[
                {Description: 'No. inventaire', Column: 'ProductNumber'},
                {Description: 'No. modèle', Column: 'ModelNumber'},
                {Description: 'Modèle', Column: 'TrailerModel', format: {type: 'relation', displayColumn: 'Description'}},
                {Description: 'Marque', Column: 'Make', format: {type: 'relation', displayColumn: 'Description'}},
                {Description: 'Année', Column: 'Year'},
                {Description: 'Prix', Column: 'Price', format: {type: 'money'}},
                {Description: 'Codes postaux', Column: 'PostalCodes', sortable: false, dataAlias: '', style: Styles.optionsButton, format: {type: 'button', displayColumn: 'JSON.parse(cell || "[]").length', action: this.openPostalCodesDialog, content: <PostalCodeIcon/> }}
              ]}/>
            </div>
            <div>
              {this.state.sendConfirmTrailersCount} remorques seront envoyées.
            </div>
        </Dialog>
        <Dialog
          modal={false}
          open={this.state.postalCodesDialogOpen}
          onRequestClose={this.closePostalCodesDialog}
          title='Codes postaux'
          contentStyle={Styles.postalCodesdialogContentStyle}
          autoScrollBodyContent={true}
          actions={
            [
              <FlatButton
                label="Annuler"
                primary={true}
                onTouchTap={() => this.onPostalCodesDialogConfirm(false)}
              />,
              <FlatButton
                label="Ok"
                primary={true}
                keyboardFocused={true}
                onTouchTap={() => this.onPostalCodesDialogConfirm(true)}
              />,
            ]
          }>
            <div>
              <table>
                <tbody>
                  {this.state.selectedEntityTempPostalCodes.map((postalCode, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <SelectField
                            menuStyle={{backgroundColor: 'white'}}
                            errorText={((!postalCode || postalCode.length === 0)) && 'Ce champ est requis'}
                            floatingLabelText='Code postal'
                            children={this.state.availablePostalCodes}
                            value={postalCode}
                            onChange={(event, key, payload) => this.handleSelectPostalCodeFieldChanged(index, event, key, payload)}
                            maxHeight={200}/>
                        </td>
                        <td><RaisedButton label='Supprimer' style={{marginLeft: '10px', marginTop: '20px'}} onTouchTap={() => this.removePostalCode(index)}/></td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
              <div style={{marginTop: '10px'}}><RaisedButton label='Ajouter' onTouchTap={this.addPostalCode}/></div>
            </div>
        </Dialog>
        <EntityList apiRoute='api/trailers' baseCriteria='count=1000&scope=active' title='LesPAC' editTitle='LesPAC' allowEdit={false} allowAdd={false} allowDelete={false} defaultOrderBy='-LesPACActive' displayColumns={[
          {Description: 'Actif sur LesPAC', Column: 'LesPACActive', sortable: true, format: {type: 'boolean', inlineEdit: true}},
          {Description: 'No. inventaire', Column: 'ProductNumber'},
          {Description: 'No. modèle', Column: 'ModelNumber'},
          {Description: 'Modèle', Column: 'TrailerModel', format: {type: 'relation', displayColumn: 'Description'}},
          {Description: 'Marque', Column: 'Make', format: {type: 'relation', displayColumn: 'Description'}},
          {Description: 'Année', Column: 'Year'},
          {Description: 'Prix', Column: 'Price', format: {type: 'money'}},
        ]}/>
        <FloatingActionButton onClick={this.sendLesPAC} style={Styles.sendLesPACButton}>
          <SendIcon />
        </FloatingActionButton>
        <Snackbar
          open={this.state.sendResultOpen}
          message={this.state.sendResultMessage}
          onRequestClose={this.handleSendResultRequestClose}
          autoHideDuration={4000}
        />
      </div>
    )
  }
}

export default TrailersLesPAC;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/trailers.lesPAC.js
 **/